/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット開始パネル
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-join-pane">

  <el-main class="main-area">
    <p class="information-text">{{$t('基本情報を入力し「チャットを始める」ボタンをクリックしてください。')}}</p>
    <el-form ref="fastchatUserInfoForm" :model="fastchatUserInfo" :rules="userCertificateFlg ? rulesCertificate : rulesNoCertificate" @submit.native.prevent="doChatJoin">
      <el-form-item class="form-item" :label="$t('氏名(カナ)')" required></el-form-item>
      <div style="display: flex">
        <el-form-item prop="lnameKana" class="form-item">
          <el-input type="text" class="name-input" :maxlength="200" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.lnameKana" :placeholder="$t('セイ')"></el-input>
        </el-form-item>
        <el-form-item prop="fnameKana" class="form-item fname-kana-form-item">
          <el-input type="text" class="name-input" :maxlength="200" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.fnameKana" :placeholder="$t('メイ')"></el-input>
        </el-form-item>
      </div>
      <el-form-item :label="$t('電話番号')" class="form-item cust-tel-form-item" prop="custTel">
        <el-input type="tel" class="name-input cust-tel-input" :maxlength="64" size="30" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.custTel" :placeholder="$t('携帯電話番号（ハイフンなし）')"></el-input>
      </el-form-item>
      <el-form-item class="form-item" :label="$t('生年月日')" required></el-form-item>
      <div style="display: flex">
        <el-form-item prop="year" class="form-item">
          <el-select ref="yearSelect" class="birthday-select-year" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.year" @focus="birthdayFocusHandler" @change="yearsMonthsChangeHandler" placeholder="">
            <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>{{$t('年')}}</span>
        </el-form-item>
        <el-form-item prop="month" class="form-item">
          <el-select class="birthday-select-month" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.month" @focus="birthdayFocusHandler" @change="yearsMonthsChangeHandler" placeholder="">
            <el-option v-for="item in months" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>{{$t('月')}}</span>
        </el-form-item>
        <el-form-item prop="day" class="form-item">
          <el-select class="birthday-select-day" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.day" @focus="birthdayFocusHandler" placeholder="">
            <el-option v-for="item in days" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>{{$t('日')}}</span>
        </el-form-item>
      </div>
      <el-form-item class="form-item" :label="$t('ご利用状況')" required></el-form-item>
      <el-form-item prop="nuroOpeningStatus" class="form-item" required>
          <el-select size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.nuroOpeningStatus" placeholder="">
            <el-option v-for="nuroOpeningStatus in openingStatus" :key="nuroOpeningStatus" :label="nuroOpeningStatus" :value="nuroOpeningStatus">
            </el-option>
          </el-select>
       </el-form-item>
      <el-form-item class="form-item" :label="$t('お問い合わせ内容')" required></el-form-item>
      <el-form-item prop="probType" class="form-item" required>
          <el-select size="small" :disabled="!permissionInputFastchatUserInfoForm" :style="probTypeSelectStyle" v-model="fastchatUserInfo.probType" placeholder="">
            <el-option v-for="probType in probTypeList" v-if="probType.displayable" :key="probType.value" :label="probType.label" :value="probType.value">
            </el-option>
          </el-select>
       </el-form-item>
    </el-form>
    <p class="user-certificate-explanation" v-text="userCertificateExplanation"></p>
  </el-main>

  <el-user-certificate-result-dialog ref="userCertificateResultDialog" v-show="showUserCertificateResultDialogFlg" @showUserCertificate="showUserCertificateHandler" @showUserNoCertificate="showUserNoCertificateHandler">
  </el-user-certificate-result-dialog>

  <el-footer class="footer-area" height="auto">
    <el-button type="primary" class="chat-join-button" :disabled="!permissionChatJoin" @click="doChatJoin">{{$t('チャットを始める')}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option
} from 'element-ui'
import ServiceUtil from '@/utils/ServiceUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import ChatConst from '@/constants/ChatConst'
import DialogUtil from '@/utils/DialogUtil'
import DateUtil from '@/utils/DateUtil'
import FcChatUserCertificateResultDialog from './dialog/FcChatUserCertificateResultDialog'

export default {
  name: 'FcChatJoinPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-button': Button,
    'el-select': Select,
    'el-option': Option,
    'el-user-certificate-result-dialog': FcChatUserCertificateResultDialog
  },
  data() {
    return {
      /**
       * FastChatユーザー情報
       * @type {Object}
       */
      fastchatUserInfo: {
        /**
         * 氏名(カナ)‐セイ
         * @type {String}
         */
        lnameKana: '',
        /**
         * 氏名(カナ)‐メイ
         * @type {String}
         */
        fnameKana: '',
        /**
         * 電話番号
         * @type {Number}
         */
        custTel: null,
        /**
         * 生年月日‐年
         * @type {String}
         */
        year: null,
        /**
         * 生年月日‐月
         * @type {String}
         */
        month: null,
        /**
         * 生年月c‐月
         * @type {String}
         */
        day: null,
         /**
         * ご利用状況
         * @type {String}
         */
         nuroOpeningStatus: '',
         /**
         * お問い合わせ内容
         * @type {String}
         */
         probType: ''
      },
      rulesCertificate: {
        lnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        fnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        custTel: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }, {
          pattern: /^[0-9]*$/,
          message: this.$t('半角数字で入力してください'),
          trigger: 'blur'
        }],
        year: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        month: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        day: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        nuroOpeningStatus: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        probType: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }]
      },
      rulesNoCertificate: {
        lnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        fnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        custTel: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }, {
          pattern: /^[0-9]*$/,
          message: this.$t('半角数字で入力してください'),
          trigger: 'blur'
        }],
        year: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        month: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        day: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        nuroOpeningStatus: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        probType: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }]
      },
      /**
       * チャットユーザー情報のvalid状態
       * @type {Boolean}
       */
      validFastchatUserInfo: false,
      /**
       * FastChatサービス状態取得サービスをリクエスト中か
       * @type {Boolean}
       */
      requestingFindFastchatServiceStatus: false,
      /**
       * 無効状態
       * @type {Boolean}
       */
      disabled: false,
      /**
       * ユーザ認証フラグ
       * @type {Boolean}
       */
      userCertificateFlg: false,

      /**
       * ユーザ認証結果ダイアログの表示
       * @type {Boolean}
       */
      showUserCertificateResultDialogFlg: false,

      /**
       * ユーザ認証失敗回数
       * @type {Number}
       */
      userCertificateFailedCount: 0,

      /**
       * 生年月日選択リスト‐年
       * @type {List}
       */
      years: null,

      /**
       * 生年月日選択リスト‐月
       * @type {List}
       */
      months: null,

      /**
       * 生年月日選択リスト‐日
       * @type {List}
       */
      days: null,

      /**
       * ユーザ認証時の文言
       * @type {String}
       */
      userCertificateExplanation: this.$t('ご入力いただいた内容は、お客さまの契約確認に利用させていただきます。\n\n※当フォームは送信経路上のセキュリティ確保のために、暗号化してデータを送信する方式（SSL）を採用しております。\n※チャットのお問い合わせフォームから入力された内容は、お客さまのサポートにのみ利用されます。お客さまの許可なく、そのほかの目的に使用されることはございません。'),

       /**
       * ご利用状況
       * @type {List}
       */
      openingStatus: null,

       /**
       * お問い合わせ内容
       * @type {List}
       */
      probTypeList: null
    }
  },
  beforeMount() {
    this.years = DateUtil.getYears(ChatConst.BIRTHDAY_YEAR_START)
    this.months = DateUtil.getMonths()
    this.days = DateUtil.getDays()
    this.openingStatus = this.getOpeningStatus()
    this.probTypeList = this.getProbTypeList()
  },
  mounted() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
    // 年のスクロール調整
    this.setScrollPosition(this.$refs.yearSelect, 1997)
  },
  updated() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
  },
  computed: {
    /**
     * チャットユーザー情報フォームへの入力が可能か
     * @return {Boolean}
     */
    permissionInputFastchatUserInfoForm() {
      return !this.requestingFindFastchatServiceStatus && !this.disabled
    },
    /**
     * 「チャットを始める」の実行が可能か
     * @return {Boolean}
     */
    permissionChatJoin() {
      return !this.requestingFindFastchatServiceStatus && this.validFastchatUserInfo && !this.disabled
    },
    /**
     * お問い合わせ内容のstyleを取得。
     * @return {string}
     */
    probTypeSelectStyle() {
      const span = document.createElement('span')
      span.style.visibility = 'hidden'
      span.style.fontSize = '14px'
      document.body.appendChild(span)
      var width = 0
      for (const probType of this.probTypeList) {
        if (probType.displayable) {
          span.innerText = probType.label
          width = Math.max(width, span.offsetWidth)
        }
      }
      document.body.removeChild(span)
      // Add arrow icon width
      width = width + 25
      return {
        width: width + 'px',
        minWidth: '340px',
        maxWidth: '500px'
      }
    }
  },
  methods: {
    /**
     * 生年月日のフォーカスイベント処理
     * @param  {FocusEvent} event
     */
    birthdayFocusHandler(event) {
      // IE11でポップアップの後ろの入力カーソルが見える為、フォーカスを外す
      if (event.srcElement != null) {
        event.srcElement.blur()
      }
    },

    /**
     * チャットユーザー情報フォームのvalidate処理
     * @param  {Function} callback
     */
    validateFastchatUserInfoForm(callback) {
      this.$refs['fastchatUserInfoForm'].validate((valid) => {
        callback(valid)
      })
    },
    /**
     * 「チャットを始める」処理
     */
    doChatJoin() {
      if (!this.permissionChatJoin) {
        return
      }
      this.validateFastchatUserInfoForm((valid) => {
        if (valid) {
          if (this.$config['_nuroChatAuthStatus'] !== '4') {
            if (this.userCertificateFlg) {
              // 認証成功(個人情報入力)
              this.$config['_nuroChatAuthStatus'] = '1'
            } else {
              // 認証失敗(個人情報入力)
              this.$config['_nuroChatAuthStatus'] = '2'
            }
          }
          this.chatJoin()
        }
      })
    },
    /**
     * 「チャットを始める」処理
     */
    chatJoin() {
      ServiceUtil.request('findFastchatServiceStatusWithPreStartChat', null, {
        start: _ => {
          this.requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            if (this.$config['_nuroChatAuthStatus'] !== '3') {
              setTimeout(_ => {
                DialogUtil.showInfoDialog(responseData.message, _ => {
                  this.$emit('chatWindowClose')
                })
              }, 0)
              return
            }
          }
          this.$emit('chatJoin', this.getChatJoinParam())
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode)
        },
        end: _ => {
          this.requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * ユーザ認証結果ダイアログを表示
     */
    showUserCertificateResultDialog() {
      this.userCertificateFailedCount = this.userCertificateFailedCount + 1
      this.$refs['userCertificateResultDialog'].showUserNoCertificateBtn = this.userCertificateFailedCount > 1
      this.showUserCertificateResultDialogFlg = true
    },
    /**
     * 「入力画面に戻る」ハンドラ
     */
    showUserCertificateHandler() {
      this.showUserCertificateResultDialogFlg = false
    },
    /**
     * 「基本情報の入力なしでチャットを始める」ハンドラ
     */
    showUserNoCertificateHandler() {
      this.showUserCertificateResultDialogFlg = false
      this.userCertificateFlg = false
      // 認証なしでチャット開始
      this.doChatJoin()
    },

    /**
     * 「生年月日選択リスト‐年、月」変更ハンドラ
     */
    yearsMonthsChangeHandler() {
      this.fastchatUserInfo.day = null
      this.days = DateUtil.getDays(this.fastchatUserInfo.year, this.fastchatUserInfo.month)
    },

    /**
     * ユーザ認証モードを取得
     @return {String}
     */
    getUserCertificateMode() {
      // 認証なし
      let paramUserCertificateMode = '0'
      if (this.userCertificateFlg) {
        // 認証成功
        paramUserCertificateMode = '1'
      } else {
        if (this.userCertificateFailedCount > 0) {
          // 認証失敗
          paramUserCertificateMode = '2'
        }
      }
      return paramUserCertificateMode
    },

    /**
     * URLのクエリパラメータを取得
     @return {String}
     */
     getNuroChatInflowRouteType() {
       let paramNuroChatInflowRouteType = null
       // URL全体を取得
       const url = new URL(window.location.href)
       // パラメータが流入経路のものを取得
       paramNuroChatInflowRouteType = url.searchParams.get('inflowRoute')
       // 3桁を超える場合は空白を除去してから切り捨てる
       if (paramNuroChatInflowRouteType != null && paramNuroChatInflowRouteType.length > 3) {
         paramNuroChatInflowRouteType = paramNuroChatInflowRouteType.replace(/\s+/g, '')
         paramNuroChatInflowRouteType = paramNuroChatInflowRouteType.slice(0, 3)
       }
       return paramNuroChatInflowRouteType
     },

    /**
     * パラメータを取得
     @return {Object}
     */
    getChatJoinParam() {
      let param = {
        lnameKana: this.fastchatUserInfo.lnameKana,
        fnameKana: this.fastchatUserInfo.fnameKana,
        userCertificateMode: this.getUserCertificateMode(),
        nuroChatInflowRouteType: this.getNuroChatInflowRouteType(),
        nuroOpeningStatus: this.fastchatUserInfo.nuroOpeningStatus,
        probType: this.fastchatUserInfo.probType
      }
      if (this.fastchatUserInfo.custTel) {
        param['custTel'] = this.fastchatUserInfo.custTel
      }
      if (this.fastchatUserInfo.month && this.fastchatUserInfo.day && this.fastchatUserInfo.year) {
        param['birthday'] = new Date(this.fastchatUserInfo.month + '/' + this.fastchatUserInfo.day + '/' + this.fastchatUserInfo.year).getTime()
      }
      return param
    },

    /**
     * プルダウンのスクロールポジション調整
     */
    setScrollPosition(selector, val) {
      selector.handleMenuEnter = function() {
          const opt = selector.selected.value == null ? selector.getOption(val) : selector.selected
          selector.$nextTick(() => selector.scrollToOption(opt))
      }
    },
    /**
     * ご利用状況を取得する
     */
    getOpeningStatus() {
      return this.$extConfig['_openingStatus']
    },
    /**
     * お問い合わせ内容を取得する
     */
    getProbTypeList() {
      const fastChatProbTypeList = this.$extConfig['_fastChatProbTypeList']
      if (!fastChatProbTypeList) {
          return []
      }
      return fastChatProbTypeList.map((item, index) => ({
          label: item.probTypeLabel,
          value: item.probType,
          displayable: item.displayable
      }))
    }
  }
}
</script>

<style scoped>
.fc-chat-join-pane {
  height: 0px;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.chat-join-button {
  width: 100%;
}

.close-button {
  background: transparent;
  border: none;
  color: white;
}

.form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatJoin/FcChatJoinPane.vue